import { ofType } from 'redux-observable';
import { mergeMap } from 'rxjs/operators';

import 'isomorphic-fetch';
import { polyfill } from 'es6-promise';
import { UPDATE_USER_DATA, updateUserDataSuccess, updateUserDataFail } from '../actions/actions_updateUsers';
import util from '../../../global/utils/Helpers';
polyfill();

let apiIndex = util.isLocalhost() ? 'http://localhost:9393/auth/graphql' : `${util.getCurrentHost()}/auth/auth/graphql`;

const getQuery = (data) => {
	//let state = store.getState();
	//let currtUser = state.appReducer.userDataReducer.data;
	return JSON.stringify({
		query: `mutation {
			updateAttributes(
			  accepted_rules_of_behavior:true,
				account_type:"${data.account_type}",
			  last_name:"${data.last_name}",
			  first_name:"${data.first_name}",
			  phone_number:"${data.phone_number}",
			  extension:"${data.extension}",
			  legal_business_name:"${data.legal_business_name}",
			  federal_employer_identification: "${data.federal_employer_identification}"
			)
		  }`
	});
};
const updateUserDataEpic = (action$) =>
	action$.pipe(
		ofType(UPDATE_USER_DATA),
		mergeMap((action) =>
			fetch(apiIndex, {
				credentials: 'include',
				method: 'POST',
				headers: {
					'Content-Type': 'application/json'
				},
				body: getQuery(action.payload)
			})
				.then((res) => res.json())
				.then((data) => updateUserDataSuccess(data))
				.catch((error) => updateUserDataFail(true))
		)
	);

export default updateUserDataEpic;
